import { Config } from '../../config/config';
import { Img } from './img';
import { Publication } from './publication';

export class Job extends Publication {

    
    
    periode;
    localisation;
    profil;
    postulation;
    nbr_poste;
    type_contrat;
    domaine;
    renumeration;
    enterprise;

    constructor() {
        super();
        this.is_publish = true;
    }


    
    
    
   
  }